// Envío manual de eventos a Google Analytics 4 (gtag.js está cargado en public/index.html
// con send_page_view: false porque es una SPA y las vistas se disparan por ruta).

export function trackPageview(path, title) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
